import { render, staticRenderFns } from "./YzSimpleTable.vue?vue&type=template&id=603eab6c&scoped=true&lang=pug&"
import script from "./YzSimpleTable.vue?vue&type=script&lang=js&"
export * from "./YzSimpleTable.vue?vue&type=script&lang=js&"
import style0 from "./YzSimpleTable.vue?vue&type=style&index=0&id=603eab6c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "603eab6c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VSimpleTable})
